import { Link, Stack } from "@mui/material";
import React from "react";

// used in footer
const SocialMediaIcons = () => {
	return (
		<Stack
			direction="row"
			display={"flex"}
			alignItems={"flex-end"}
			justifyContent={"center"}
			width={"100%"}
			ml={0}
			gap={"22px"}
		>
			{/* Facebook */}
			<Link
				href="https://www.facebook.com/xtellig"
				target={"_blank"}
				rel="noopener noreferrer"
				aria-label="Facebook"
				sx={{
					display: "flex",
					alignItems: "flex-end",
					justifyContent: "center",

					"&:hover": { opacity: 0.8 },
				}}
			>
				<svg
					width="11"
					height="20"
					viewBox="0 0 11 20"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M7.14007 20V10.8771H10.3832L10.8687 7.32167H7.13998V5.0517C7.13998 4.02233 7.44268 3.32087 9.00609 3.32087L11 3.31999V0.14008C10.6551 0.0968288 9.47145 0 8.09454 0C5.21964 0 3.25144 1.65686 3.25144 4.69969V7.32167H0V10.8771H3.25144V19.9999H7.14007V20Z"
						fill="#6F6C90"
					/>
				</svg>
			</Link>

			{/* Instagram */}
			<Link
				href="https://www.instagram.com/xtelligdotcom/"
				target={"_blank"}
				rel="noopener noreferrer"
				aria-label="Instagram"
				sx={{
					display: "flex",
					alignItems: "flex-end",
					justifyContent: "center",

					"&:hover": { opacity: 0.8 },
				}}
			>
				<svg
					width="20"
					height="21"
					viewBox="0 0 20 21"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M10 0.0898438C13.9946 0.0898438 15.9921 0.0901076 17.4307 1.04199C18.0729 1.46697 18.6229 2.01696 19.0479 2.65918C19.9997 4.09778 20 6.09526 20 10.0898C20 14.0845 19.9997 16.0819 19.0479 17.5205C18.6229 18.1627 18.0729 18.7127 17.4307 19.1377C15.9921 20.0896 13.9946 20.0898 10 20.0898C6.00541 20.0898 4.00794 20.0896 2.56934 19.1377C1.92711 18.7127 1.37713 18.1627 0.952148 17.5205C0.000263851 16.0819 0 14.0845 0 10.0898C0 6.09526 0.000268095 4.09778 0.952148 2.65918C1.37713 2.01696 1.92712 1.46698 2.56934 1.04199C4.00794 0.0901118 6.00541 0.0898438 10 0.0898438ZM10 4.91406C7.14074 4.91406 4.82227 7.23254 4.82227 10.0918C4.82232 12.951 7.14077 15.2686 10 15.2686C12.8591 15.2684 15.1767 12.9509 15.1768 10.0918C15.1768 7.23261 12.8592 4.91417 10 4.91406ZM10 6.66602C11.8918 6.66613 13.4258 8.19997 13.4258 10.0918C13.4257 11.9836 11.8918 13.5175 10 13.5176C8.10814 13.5176 6.57428 11.9836 6.57422 10.0918C6.57422 8.1999 8.10811 6.66602 10 6.66602ZM15.3818 3.43848C14.71 3.43848 14.165 3.98343 14.165 4.65527C14.1653 5.32693 14.7101 5.87109 15.3818 5.87109C16.0534 5.87089 16.5974 5.32681 16.5977 4.65527C16.5977 3.98356 16.0535 3.43868 15.3818 3.43848Z"
						fill="#6F6C90"
					/>
				</svg>
			</Link>

			{/* youtube */}
			<Link
				href="https://www.youtube.com/@xtellig"
				target={"_blank"}
				rel="noopener noreferrer"
				aria-label="YouTube"
				sx={{
					display: "flex",
					alignItems: "flex-end",
					justifyContent: "center",

					"&:hover": { opacity: 0.8 },
				}}
			>
				<svg
					width="29"
					height="20"
					viewBox="0 0 29 20"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M28.1533 4.31547C28.1533 4.31547 27.8756 2.3549 27.0203 1.49403C25.9372 0.361011 24.7265 0.355457 24.1711 0.288808C20.1944 -1.58902e-07 14.2238 0 14.2238 0H14.2127C14.2127 0 8.24216 -1.58902e-07 4.26548 0.288808C3.71008 0.355457 2.49931 0.361011 1.41627 1.49403C0.560955 2.3549 0.288809 4.31547 0.288809 4.31547C0.288809 4.31547 0 6.62038 0 8.91974V11.0747C0 13.3741 0.283255 15.679 0.283255 15.679C0.283255 15.679 0.560955 17.6395 1.41072 18.5004C2.49375 19.6334 3.91558 19.5946 4.54874 19.7167C6.82588 19.9334 14.2183 20 14.2183 20C14.2183 20 20.1944 19.9889 24.1711 19.7056C24.7265 19.639 25.9372 19.6334 27.0203 18.5004C27.8756 17.6395 28.1533 15.679 28.1533 15.679C28.1533 15.679 28.4365 13.3796 28.4365 11.0747V8.91974C28.4365 6.62038 28.1533 4.31547 28.1533 4.31547ZM11.2802 13.6906V5.69842L18.9614 9.70841L11.2802 13.6906Z"
						fill="#6F6C90"
					/>
				</svg>
			</Link>

			{/* LinkedIn */}
			<Link
				href="https://www.linkedin.com/showcase/xtellig"
				target={"_blank"}
				rel="noopener noreferrer"
				aria-label="LinkedIn"
				sx={{
					display: "flex",
					alignItems: "flex-end",
					justifyContent: "center",

					m: 0,
					"&:hover": { opacity: 0.8 },
				}}
			>
				<svg
					width="21"
					height="21"
					viewBox="0 0 21 21"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M0 2.41308C0 1.73966 0.236493 1.18411 0.709459 0.746409C1.18243 0.308692 1.7973 0.0898438 2.55405 0.0898438C3.2973 0.0898438 3.89864 0.305318 4.35811 0.736308C4.83107 1.18075 5.06757 1.75986 5.06757 2.47368C5.06757 3.12015 4.83784 3.65885 4.37838 4.08984C3.90541 4.53429 3.28378 4.75651 2.51351 4.75651H2.49324C1.74999 4.75651 1.14866 4.53429 0.689189 4.08984C0.229723 3.6454 0 3.08647 0 2.41308ZM0.263514 20.0898V6.59489H4.76351V20.0898H0.263514ZM7.25676 20.0898H11.7568V12.5545C11.7568 12.0831 11.8108 11.7195 11.9189 11.4636C12.1081 11.0057 12.3953 10.6185 12.7804 10.302C13.1655 9.98546 13.6486 9.82722 14.2297 9.82722C15.7432 9.82722 16.5 10.844 16.5 12.8777V20.0898H21V12.3525C21 10.3592 20.527 8.84742 19.5811 7.81712C18.6351 6.78681 17.3851 6.27166 15.8311 6.27166C14.0878 6.27166 12.7297 7.01914 11.7568 8.51409V8.55449H11.7365L11.7568 8.51409V6.59489H7.25676C7.28378 7.02586 7.2973 8.36592 7.2973 10.6151C7.2973 12.8642 7.28378 16.0225 7.25676 20.0898Z"
						fill="#6F6C90"
					/>
				</svg>
			</Link>
		</Stack>
	);
};

export default SocialMediaIcons;
